import { render, staticRenderFns } from "./companyTable.vue?vue&type=template&id=4e56daf9"
import script from "./companyTable.vue?vue&type=script&lang=js"
export * from "./companyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports